(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.titanFaqReady === 'true') return;
    section.dataset.titanFaqReady = 'true';

    var items = Array.prototype.slice.call(section.querySelectorAll('.thf__item'));
    var singleOpen = section.dataset.singleOpen === 'true';

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!singleOpen || !item.open) return;

        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-titan-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
